export class UserModel {
    public Id: string;
    public userId: number;
    public userEmail: string;
    public userName: string;
    public userRole: string;
    public isActive: boolean;
    public createdBy: string;
    public createdOn: string;
    public updatedOn: string;
    public updatedBy: string;

}
